<div class="tw:w-full tw:px-4">
  <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">

    <div class="tw:w-1/2 tw:px-[15px]">
      <div class="tile-padding-first">
        <h3 class="tw:pt-4">Learners</h3>
      </div>
    </div>
    <div class="tw:w-1/2 tw:px-[15px]">
      @if (hasStudentDataInsertPermission) {
        <div class="tile-padding-first tw:pr-2">
          <!-- Add-learner entry point suppressed: Orbit is the source of record for learners (bug 37289 §7a). -->
          <button *ngIf="false" type="button" class="btn btn-primary tw:float-right" (click)="addStudent()">Add Learners</button>
        </div>
      }
    </div>

    <div class="tw:w-full tw:px-[15px]">

      <student-search #studentSearch
        [showClientFilter]="false"
        [clientId]="clientId"
        [injectedShowSearch]="true">
      </student-search>

    </div>

  </div>
</div>